import { render, staticRenderFns } from "./TradeProductCard.vue?vue&type=template&id=d479a10a&"
import script from "./TradeProductCard.vue?vue&type=script&lang=js&"
export * from "./TradeProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports